module.exports = __webpack_public_path__ + "img/code-6.86bde0ff.png";